import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Form,
    Alert,
    Spinner
} from 'reactstrap';

import {useSelector, useDispatch} from "react-redux";

import {Link} from "react-router-dom";
import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik} from "formik";
import {deviceSurvey, deviceSurveyStep, deviceSurveyPreviousStep, deviceSurveyStart} from "../slices/survey";
import {recordActivity} from "../slices/register";
import ReactGA from "react-ga4";
import {trackGoogleConversion} from "../utils/googleAds";

let groupings = {
    "Baseline Assessment": "Baseline Demographics for Reporting",
    "Eligibility Survey": "Assessment of Eligibility Questions",
}
const EligibilityAssessment = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const [loadingPrevious, setLoadingPrevious] = useState(false)
    const {
        surveyStartError,
        survey
    } = useSelector(state => ({
        surveyStartError: state.survey.surveyStartError,
        survey: state.survey.survey || {},
    }));

    useEffect(() => {
        let deviceId = sessionStorage.getItem('device') || undefined
        let surveyId = sessionStorage.getItem('survey') || undefined
        let stepId = sessionStorage.getItem('step') || undefined
        if (surveyId && stepId) {
            dispatch(deviceSurvey(deviceId, surveyId, stepId, (data) => {
                setLoading(false)
                if (data.step === "REDIRECT_TO_RECOVERYPAD") {
                    ReactGA.event({
                        category: "Conversion",
                        action: "eligibility_screener_completed",
                        label: "Eligibility Screener Completed", // optional
                    });
                    trackGoogleConversion('eligibility_screener_completed');
                    setTimeout(() => {
                        window.location = data.url
                    }, 5000)

                }
            }))

            dispatch(recordActivity(deviceId, {
                action: "survey",
                step_id: stepId,
                survey_id: surveyId
            }))
        } else {
            props.router.navigate('/online-enrollment')
        }
    }, [dispatch]);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: survey,
        onSubmit: (values) => {
            setLoading(true)
            let deviceId = sessionStorage.getItem('device') || undefined
            dispatch(deviceSurveyStep(deviceId, values, (data) => {
                if (data.step === "REDIRECT_TO_RECOVERYPAD") {
                    ReactGA.event({
                        category: "Conversion",
                        action: "eligibility_screener_completed",
                        label: "Eligibility Screener Completed", // optional
                    });
                    trackGoogleConversion('eligibility_screener_completed');
                    setTimeout(() => {
                        window.location = data.url
                    }, 5000)
                }
                setLoading(false)
                scrollStep()

                dispatch(recordActivity(deviceId, {
                    action: "survey",
                    step_id: data.stepId,
                    survey_id: data.surveyId
                }))
            }))
        }
    });

    const handlePreviousStep = () => {
        setLoadingPrevious(true)
        let deviceId = sessionStorage.getItem('device') || undefined
        if (survey.step === "1-1") {
            props.router.navigate('/online-enrollment')
        }
        dispatch(deviceSurveyPreviousStep(deviceId, survey.surveyId, (data) => {
            setLoadingPrevious(false)
            scrollStep()
            dispatch(recordActivity(data.deviceId, {
                action: "survey",
                step_id: data.stepId,
                survey_id: data.surveyId
            }))
        }))
    }

    const scrollStep = () => {
        setTimeout(() => {
            if (window.document.getElementById('scrollItem')) {
                window.document.getElementById('scrollItem').scrollTo({top: 0, behavior: "smooth"})
                window.document.getElementById('scrollItem').scroll({top: 0, behavior: "smooth"})
            }
        }, 100)
    }
    let isValid = true

    validation.values.questions?.forEach(que => {
        if (que.required && isValid) {
            if (que.question_type === "textbox-integer") {
                isValid = !!(que.answers[0]?.answer && que.answers[0].answer !== "")
            } else {
                isValid = que.answers.filter(item => item.selected)?.length > 0
            }
        }
    })

    const renderBody = (body = []) => {
        return body.map((item, index) => {
            const Tag = item.type || "p";

            let styleObj = {};
            if (item.style && typeof item.style === "string") {
                try {
                    styleObj = Object.fromEntries(
                        item.style.split(",").map(rule => {
                            const [key, value] = rule.split(":");
                            return [key.trim(), value.replace(/"/g, "").trim()];
                        })
                    );
                } catch (e) {
                    console.error("Invalid style format", item.style);
                }
            }

            const hasHtml = item.html && item.html.trim() !== "";

            if (hasHtml) {
                return (
                    <Tag
                        key={index}
                        style={styleObj}
                        className={item.class || ""}
                        dangerouslySetInnerHTML={{__html: item.html}}
                    />
                );
            }

            return (
                item.type === "br" ? <br key={index}/> : <Tag
                    key={index}
                    style={styleObj}
                    className={item.class || ""}
                >
                    {item.text}
                </Tag>
            );
        });
    };

    document.title = "Eligibility Survey";
    return (
        <React.Fragment>
            <div>
                <Container>
                    <Row className="pt-5 justify-content-center">
                        <Col className="p-0" xl={8} md={10} sm={12}>
                            <div className="text-center mt-2">
                                {survey.step === "REDIRECT_TO_RECOVERYPAD" ?
                                    <h3>Redirecting...</h3> :
                                    <h3>Eligibility Survey</h3>}

                            </div>
                            <Card className="p-2 mt-4">
                                <CardBody className="p-4 eligibility" id="scrollItem">
                                    {surveyStartError && surveyStartError ? (
                                        <Alert color="danger"> {surveyStartError} </Alert>) : null}
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                        style={{height: "calc(100% - 30px)"}}
                                        action="#">
                                        {survey.step === "REDIRECT_TO_RECOVERYPAD" ?
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: "column",
                                                height: "100%",
                                                justifyContent: "space-around",
                                                paddingRight: 15
                                            }}>
                                                <h6 style={{
                                                    textAlign: "center",
                                                    marginBottom: 0
                                                }}>PLEASE WAIT...</h6>
                                            </div>
                                            :
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: "column",
                                                height: "100%",
                                                justifyContent: "space-between",
                                                paddingRight: 15
                                            }}>
                                                <div>
                                                    {validation?.values?.header?.body && validation.values.header.body.length > 0 &&
                                                        <>
                                                            {renderBody(validation.values.header.body)}
                                                            <br/>
                                                        </>
                                                    }
                                                    {/*<h6 style={{*/}
                                                    {/*    textAlign: "center",*/}
                                                    {/*    marginBottom: 0*/}
                                                    {/*}}>{groupings[survey.step_grouping]} </h6>*/}
                                                    {/*<p className={"font-normal"}>{survey.required ? "(responses are required)" : "(optional, responses not required)"}</p>*/}
                                                    {
                                                        validation.values.questions && validation.values.questions.map((que, ind) => {
                                                            return <div key={ind}>
                                                                <h5>
                                                                    {que.question}
                                                                </h5>
                                                                {que.question_type === "textbox-integer" ? (
                                                                    <Row>
                                                                        <Col xl={6} md={12} sm={12}>
                                                                            <input
                                                                                type="text"
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                className="form-control mt-2"
                                                                                value={que.answers[0]?.answer || ""}
                                                                                min={0}
                                                                                max={999}
                                                                                step={1}
                                                                                onChange={(e) => {
                                                                                    console.log(e.target.value)
                                                                                    const raw = e.target.value.replace(/[^0-9]/g, '')
                                                                                    const num = parseInt(raw, 10)
                                                                                    const val = raw === "" ? "" : isNaN(num) || num < 0 ? "" : raw
                                                                                    const exponent = raw.indexOf("e")
                                                                                    if ((!isNaN(num) || raw === "" ) && raw.length <= 3 && exponent == -1) {
                                                                                        let questions = Object.assign([], validation.values.questions)
                                                                                        let answers = Object.assign([], questions[ind].answers)
                                                                                        answers[0] = {
                                                                                            ...answers[0],
                                                                                            answer: val,
                                                                                            selected: val !== ""
                                                                                        }
                                                                                        questions[ind] = {
                                                                                            ...questions[ind],
                                                                                            answers
                                                                                        }
                                                                                        validation.setFieldValue("questions", questions)
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                ) : (
                                                                    <Row>
                                                                        <Col className="pr-5 pl-5 justify-content-center"
                                                                             xl={6} md={12} sm={12}>
                                                                            {que.answers?.map((item, index) => {
                                                                                return index % 2 == 0 &&
                                                                                    <div className="mt-3" key={index}>
                                                                                        <Button
                                                                                            aria-label={"choice " + item.answer}
                                                                                            className={"btn button-primary choice btn w-100 " + (item.selected ? "choice-selected" : "")}
                                                                                            onClick={() => {
                                                                                                let answers = Object.assign([], validation.values.questions[ind].answers)

                                                                                                if (item.answer === "I have not experienced any of these symptoms") {
                                                                                                    answers = Object.assign([], validation.values.questions[ind].answers.filter(thisItem => thisItem.answer !== "I have not experienced any of these symptoms").map(thisItem => {
                                                                                                        let newItem = {...thisItem}
                                                                                                        if (!item.selected === true)
                                                                                                            newItem.selected = false
                                                                                                        return newItem
                                                                                                    }))
                                                                                                } else {
                                                                                                    let found = answers.find(item => item.answer === "I have not experienced any of these symptoms")
                                                                                                    if (found) {
                                                                                                        answers[found.order] = {
                                                                                                            ...found,
                                                                                                            selected: false
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                if (validation.values.questions[ind].answer_type === "single") {
                                                                                                    answers = Object.assign([], answers.map(item => {
                                                                                                        return {
                                                                                                            ...item,
                                                                                                            selected: false
                                                                                                        }
                                                                                                    }))
                                                                                                }
                                                                                                answers[index] = {
                                                                                                    ...item,
                                                                                                    selected: !item.selected
                                                                                                }
                                                                                                let questions = Object.assign([], validation.values.questions)
                                                                                                questions[ind] = {
                                                                                                    ...questions[ind],
                                                                                                    answers
                                                                                                }
                                                                                                console.log(answers, questions)

                                                                                                validation.setFieldValue("questions", questions)
                                                                                            }}>
                                                                                            {item.answer}
                                                                                        </Button>
                                                                                    </div>
                                                                            })}

                                                                        </Col>

                                                                        <Col
                                                                            className="pr-5 pl-5 justify-content-center"
                                                                            xl={6} md={12} sm={12}>
                                                                            {que.answers?.map((item, index) => {
                                                                                return index % 2 != 0 &&
                                                                                    <div className="mt-3" key={index}>
                                                                                        <Button
                                                                                            aria-label={"choice " + item.answer}
                                                                                            className={"btn button-primary choice btn w-100 " + (item.selected ? "choice-selected" : "")}
                                                                                            onClick={() => {
                                                                                                let answers = Object.assign([], validation.values.questions[ind].answers)

                                                                                                if (item.answer === "I have not experienced any of these symptoms") {
                                                                                                    answers = Object.assign([], validation.values.questions[ind].filter(thisItem => thisItem.answer !== "I have not experienced any of these symptoms").map(thisItem => {
                                                                                                        console.log(item)
                                                                                                        let newItem = {...thisItem}
                                                                                                        if (!item.selected === true)
                                                                                                            newItem.selected = false
                                                                                                        return newItem
                                                                                                    }))
                                                                                                    console.log(answers)
                                                                                                } else {
                                                                                                    let found = answers.find(item => item.answer === "I have not experienced any of these symptoms")
                                                                                                    if (found) {
                                                                                                        answers[found.order] = {
                                                                                                            ...found,
                                                                                                            selected: false
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                if (validation.values.questions[ind].answer_type === "single") {
                                                                                                    answers = Object.assign([], answers.map(item => {
                                                                                                        return {
                                                                                                            ...item,
                                                                                                            selected: false
                                                                                                        }
                                                                                                    }))
                                                                                                }
                                                                                                answers[index] = {
                                                                                                    ...item,
                                                                                                    selected: !item.selected
                                                                                                }
                                                                                                let questions = Object.assign([], validation.values.questions)
                                                                                                questions[ind] = {
                                                                                                    ...questions[ind],
                                                                                                    answers
                                                                                                }
                                                                                                validation.setFieldValue("questions", questions)
                                                                                            }}>
                                                                                            {item.answer}
                                                                                        </Button>
                                                                                    </div>
                                                                            })}
                                                                            {validation.values.questions[ind].question && validation.values.questions[ind].answers && validation.values.questions[ind].question?.indexOf("Please select all applicable symptoms") != -1 &&
                                                                                !validation.values.questions[ind].answers?.find(item => item.answer === "I have not experienced any of these symptoms") &&
                                                                                <div className="mt-3">
                                                                                    <Button
                                                                                        className={"btn button-primary choice btn w-100 " + (validation.values.questions[ind].answers[validation.values.questions[ind].answers.length]?.selected ? "choice-selected" : "")}
                                                                                        aria-label={"I have not experienced any of these symptoms"}
                                                                                        onClick={(e, value) => {
                                                                                            let answers = Object.assign([], validation.values.questions[ind].answers.map(item => {
                                                                                                let newItem = {...item}
                                                                                                newItem.selected = false
                                                                                                return newItem
                                                                                            }))
                                                                                            let found = answers.find(item => item.answer === "I have not experienced any of these symptoms")
                                                                                            if (found) {
                                                                                                answers[found.order] = {
                                                                                                    ...found,
                                                                                                    selected: false
                                                                                                }
                                                                                            } else {
                                                                                                answers[validation.values.questions[ind].answers.length] = {
                                                                                                    answer: "I have not experienced any of these symptoms",
                                                                                                    id: validation.values.questions[ind].answers.length + 1,
                                                                                                    order: validation.values.questions[ind].answers.length,
                                                                                                    selected: true
                                                                                                }
                                                                                            }
                                                                                            let questions = Object.assign([], validation.values.questions)
                                                                                            questions[ind] = {
                                                                                                ...questions[ind],
                                                                                                answers
                                                                                            }
                                                                                            validation.setFieldValue("questions", questions)
                                                                                        }}>
                                                                                        I have not experienced any of these
                                                                                        symptoms
                                                                                    </Button>
                                                                                </div>
                                                                            }
                                                                        </Col>

                                                                    </Row>
                                                                )}
                                                                {validation.values.questions && validation.values.questions.length > 1 && validation.values.questions.length - 1 !== ind ?
                                                                    <>
                                                                        <br/>
                                                                        <hr/>
                                                                    </>
                                                                    : null}
                                                                <br/>
                                                            </div>
                                                        })
                                                    }
                                                    {validation?.values?.footer?.body &&
                                                        renderBody(validation.values.footer.body)
                                                    }
                                                    <br/>
                                                    {survey.footer && survey.footer.body.map((item, index) => {
                                                        let component = item.type === 'h6' ?
                                                            <h6 key={index} style={{
                                                                textAlign: "center",
                                                                marginBottom: 0
                                                            }}
                                                                className={item.class}>{item.text}</h6> : item.type === 'p' ?
                                                                <p className={item.class}>{item.text}</p> : item.type === 'br' ?
                                                                    <br/> :
                                                                    item.text
                                                        return component
                                                    })}
                                                </div>
                                                <div className="mt-4">
                                                    <Button aria-label={"previous"}
                                                            disabled={loadingPrevious ? true : false}
                                                            className="btn button-secondary" type="button"
                                                            onClick={handlePreviousStep}>
                                                        Prev
                                                    </Button>
                                                    <Button aria-label={"next"}
                                                            disabled={loading ? true : !isValid}
                                                            className="btn button-primary pull-right" type="submit">
                                                        Next
                                                    </Button>
                                                </div>
                                            </div>
                                        }
                                    </Form>
                                    <br/>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
        ;
};

export default withRouter(EligibilityAssessment);
